import classNames from 'classnames';

interface FormHelperProps {
  text: string;
  className?: string;
  id?: string;
}

export const FormHelper = ({ text, className, id }: FormHelperProps) => {
  return (
    <p id={id} className={classNames('body-text text-grey-500 text-left', className ?? 'mt-1.5')}>
      {text}
    </p>
  );
};
